"use strict";
exports.__esModule = true;
exports.RxpPropertyCobrandingExperiment = exports.RxpPropertyCobrandingExperimentVariantValues = void 0;
var types_1 = require("../types");
var RxpPropertyCobrandingExperimentVariantValues;
(function (RxpPropertyCobrandingExperimentVariantValues) {
    RxpPropertyCobrandingExperimentVariantValues["Treatment"] = "treatment";
})(RxpPropertyCobrandingExperimentVariantValues = exports.RxpPropertyCobrandingExperimentVariantValues || (exports.RxpPropertyCobrandingExperimentVariantValues = {}));
exports.RxpPropertyCobrandingExperiment = {
    variantID: 'property-co-branding',
    controlValue: types_1.CONTROL,
    variantValues: RxpPropertyCobrandingExperimentVariantValues
};
